var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticClass:"button",attrs:{"round":"","size":"mini"}},[_c('a',{attrs:{"href":_vm.item.url,"download":""}},[_vm._v("下载 V"+_vm._s(_vm.item.version))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }